import { sendTeaCommEvent } from 'lib/tea-analyze'

type TParams = Record<string, any>
const eventMap: Record<string, string> = {
  series: 'picture_below_car_series_entrance',
  image: 'pgc_article_picture_entrance_clk',
  config: 'picture_below_parameter_configure_button',
  score: 'picture_below_dscore_entrance',
  eval: 'picture_below_dcd_evaluation_entrance',
  community: 'picture_below_forum_entrance',
  usedCar: 'picture_below_car_used_entrance',
  dealer: 'car_series_picture_ask_floor_price',
}
export default function relationSeriesTeaEvent(type: string, params?: TParams) {
  sendTeaCommEvent('clk_event', {
    event_id: eventMap[type],
    module_id: 'picture_relation_car_series_module',
    ...params,
  })
}
